import { useAppStateStore } from "~/store/appState"
import Swal from 'sweetalert2'

export const useInternet = () => {

  const appStateStore = useAppStateStore()

  const locale = computed(() => appStateStore.locale)

  const checkIsOnline = async () => {
    const url = 'https://www.google.com/generate_204'

    return fetch(url, { method: 'HEAD', mode: 'no-cors' })
      .then(() => true)
      .catch(() => false);
  }

  const alertError = () => {
    Swal.fire({
      icon: 'error',
      title: locale.value === 'th' ? 'คุณออฟไลน์อยู่' : 'You are offline',
      text: locale.value === 'th' ? 'กรุณาเชื่อมต่ออินเทอร์เน็ตเพื่อดำเนินการต่อ' : 'Please connect to the internet to continue',
    })
  }

  return {
    checkIsOnline,
    alertError
  };
}